import { render, staticRenderFns } from "./CurrMonthOverview.vue?vue&type=template&id=f156db86&scoped=true"
import script from "./CurrMonthOverview.vue?vue&type=script&lang=js"
export * from "./CurrMonthOverview.vue?vue&type=script&lang=js"
import style0 from "./CurrMonthOverview.vue?vue&type=style&index=0&id=f156db86&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f156db86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f156db86')) {
      api.createRecord('f156db86', component.options)
    } else {
      api.reload('f156db86', component.options)
    }
    module.hot.accept("./CurrMonthOverview.vue?vue&type=template&id=f156db86&scoped=true", function () {
      api.rerender('f156db86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/PsychologicalMonthReport/components/CurrMonthOverview.vue"
export default component.exports